import React, { Fragment, useState, useEffect } from "react";
import Spinner from "../layout/Spinner";
import ReportDevices from "./ReportDevices";
import { Tabs, Tab } from "@mui/material";
import useClearAlertsOnChange from "../../hooks/useClearAlertsOnChange";

const ReportSpace = ({ getAllDevice, allDevice, report: { spaces, loading }, homeId }) => {
  const [selectedData, setSelectedData] = useState({});
  const [activeTabIndex, setActiveTabIndex] = useState(0);

  useClearAlertsOnChange(activeTabIndex);

  useEffect(() => {
    if (!(spaces && spaces.length > 0)) return;

    let deviceIds = [];
    let deviceData = [];
    for (let i = 0; i < spaces.length; i++) {
      if (spaces[i].devices.length > 0) {
        deviceData.push(spaces[i].devices.length);
        for (let j = 0; j < spaces[i].devices.length; j++) {
          deviceIds.push(spaces[i].devices[j].deviceId);
        }
      }
    }
    if (allDevice.length === 0 && deviceData.length > 0)
      getAllDevice(deviceIds.join(","));

    if (allDevice.length !== 0) {
      for (let k = 0; k < allDevice.length; k++) {
        for (let i = 0; i < spaces.length; i++) {
          if (spaces[i].devices.length > 0) {
            for (let j = 0; j < spaces[i].devices.length; j++) {
              if (spaces[i].devices[j].deviceId === allDevice[k].deviceId) {
                spaces[i].devices[j]["categoy"] = allDevice[k].category;
              }
            }
          }
        }
      }
    }

    setSelectedData(spaces[0]);
    setActiveTabIndex(0);
  }, [allDevice]);

  const handleTabChange = (event, newIndex) => {
    setActiveTabIndex(newIndex);
    setSelectedData(spaces[newIndex]);
  };

  return loading ? (
    <Spinner />
  ) : (
    spaces &&
    spaces.length > 0 && (
      <Fragment>
        <Tabs
          value={activeTabIndex}
          onChange={handleTabChange}
          variant="scrollable"
          scrollButtons={false}
          TabIndicatorProps={{ sx: { backgroundColor: "#ED6C02" } }}
          sx={{
            mb: 2.5,
            // Match device row: native horizontal scroll, no prev/next arrow buttons
            "& .MuiTabs-scroller": {
              overflowX: "auto",
              overflowY: "hidden",
              WebkitOverflowScrolling: "touch",
              msOverflowStyle: "auto",
              scrollbarWidth: "thin",
            },
            "& .MuiTabs-flexContainer": {
              gap: 2,
            },
            "& .MuiTab-root": {
              textTransform: "capitalize",
              color: "#333",
              fontWeight: 500,
              px: 0,
              minWidth: "auto",
            },
            "& .MuiTab-root.Mui-selected": {
              color: "#ED6C02",
              fontWeight: 700,
            },
            "& .MuiTabs-indicator": {
              backgroundColor: "#ED6C02",
            },
          }}
        >
          {spaces.map((space) => (
            <Tab key={space.spaceId} label={space.spaceName} disableRipple />
          ))}
        </Tabs>

        {Object.keys(selectedData).length > 0 && (
          <ReportDevices selectedData={selectedData} homeId={homeId} />
        )}
      </Fragment>
    )
  );
};

ReportSpace.propTypes = {};
export default ReportSpace;
